<template>
    <form-partition :title="title" ref="info" :rules="innerRules" :model="info">
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="leaseDate" label="合同起止">
                    <Input v-model="info.leaseDate" viewonly></Input>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem prop="buildArea" label="建筑面积">
                    <input-number
                        v-if="info.buildArea"
                        v-model="info.buildArea"
                        placeholder
                        :disabled="type === '2'"
                        viewonly
                    >
                        <span slot="append">㎡</span>
                    </input-number>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="unitPrice" label="单价">
                    <input-number
                        v-if="info.unitPrice"
                        v-model="info.unitPrice"
                        placeholder
                        :min="0"
                        viewonly
                    >
                        <span slot="append">元/㎡/月</span>
                    </input-number>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem prop="rent" label="租金">
                    <input-number
                        v-model="info.rent"
                        placeholder
                        :min="0"
                        viewonly
                    >
                        <span slot="append">元/月</span>
                    </input-number>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="deposit" label="押金总额">
                    <!-- 退租 换房 -->
                    <span v-if="isSurrender || isChange">
                        <!-- {{
                            (info.deposit - 0 + (info.addAmount - 0))
                                | currency
                        }}元 = {{ (info.deposit - 0) | currency }}元 (常规押金)
                        +{{ info.addAmount | currency }}元 (增收押金) -->
                        {{ leaseLeftAmountTextOriginal }}
                    </span>
                    <input-number
                        v-model="info.deposit"
                        placeholder
                        :min="0"
                        viewonly
                        v-else
                    >
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem prop="changeReason" :label="reason">
                    <Select v-model="info.changeReason" transfer>
                        <Option
                            v-for="item in dict.changeReason.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
            </Col>
        </Row>
        <div v-if="isSurrender || isChange">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="rentMode" label="交租方式">
                        <rent-mode
                            isVerify
                            spread-out
                            :depositPayMethod="info.depositPayMethod"
                            :rentPayMethod="info.rentPayMethod"
                            viewonly
                        />
                    </FormItem>
                </Col>
                <Button
                    style="position: relative; left: -200px"
                    v-if="$can('view') && isRentCustom"
                    type="primary"
                    ghost
                    @click="modal.showRentCustom = true"
                >
                    查看自定义账期
                </Button>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="increase" label="租金涨幅">
                        <rent-increase-period
                            v-if="isRentCustom"
                            :value="info.increase"
                            :startDate="info.startDate"
                            :endDate="info.endDate"
                            :rentPayMethod="info.rentPayMethod"
                            :mergeList="info.mergeList"
                            viewonly
                        />
                        <rent-increase
                            v-else
                            :value="info.increase"
                            :year-span="increaseYear"
                            viewonly
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="discount" label="租金优惠">
                        <rent-discount
                            :value="info.discount"
                            :discountType="info.discountType"
                            :startDate="info.startDate"
                            :endDate="info.endDate"
                            :rentPayMethod="info.rentPayMethod"
                            :mergeList="info.mergeList"
                            viewonly
                        />
                    </FormItem>
                </Col>
            </Row>
        </div>
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="fList" label="交接清单">
                    <facility-list
                        v-model="info.fList"
                        :remark="fListRemark"
                        justRead
                    />
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem prop="signUser" label="签约人">
                    <Input :value="info.signUser" viewonly />
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20" v-if="isChange">
            <Col span="12">
                <FormItem prop="agentUser" label="经办人">
                    <Input :value="info.agentUser" viewonly />
                </FormItem>
            </Col>
        </Row>
        <div v-if="isSurrender">
            <Row :gutter="20">
                <Col span="12" style="position: relative">
                    <FormItem prop="attachments" label="添加附件">
                        <preview-upload v-model="info.attachments" />
                    </FormItem>
                    <div style="position: absolute; left: 70px; bottom: 10px">
                        上传身份证正反面
                    </div>
                </Col>
                <Col span="12">
                    <FormItem prop="agentUser" label="经办人">
                        <Input :value="info.agentUser" viewonly />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="remark" label="备注">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </div>
        <!-- 弹出层 @close-by-confirm="search"-->
        <smart-modal
            v-model="modal.showRentCustom"
            title="自定义账期"
            :width="800"
            :height="500"
            :maskClosable="false"
        >
            <rent-custom-form
                v-if="modal.showRentCustom"
                :startDate="ymd(info.startDate)"
                :endDate="ymd(info.endDate)"
                :mergeList="info.mergeList"
                :viewonly="true"
            />
        </smart-modal>
    </form-partition>
</template>
<script>
import { Field } from 'ivux'
import Dict from '_u/dict'
import { ymd } from '_u/helper'
import { cInfoList } from '@/api/customer'

import PreviewUpload from '_c/preview-upload'
import FacilityList from '_vc/fields/facility-list'
import RentMode from '_vc/fields/rent-mode'
import RentIncrease from '_vc/fields/rent-increase'
import RentIncreasePeriod from '_vc/fields/rent-increase-period'
import RentDiscount from '_vc/fields/rent-discount'
import RentCustomForm from './rent-custom-form'

export default {
    name: 'LeaseInfoOriginal',

    mixins: [Field],

    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        type: {
            type: [Number, String],
            default: '',
        },
        title: {
            type: String,
            default: '租约信息',
        },
        leaseLeftAmountTextOriginal: {
            type: String,
            default: '',
        },
        justRead: {
            type: Boolean,
            default: false,
        },
        populateType: {
            type: String,
            default: 'through',
        },
    },
    components: {
        PreviewUpload,
        FacilityList,
        RentMode,
        RentIncrease,
        RentDiscount,
        RentIncreasePeriod,
        RentCustomForm,
    },
    data() {
        return {
            info: {
                leaseDate: '', // 合同起止
                buildArea: '', // 建筑面积
                unitPrice: '', // 单价
                rent: '', // 租金
                deposit: '', // 押金
                leftAmount: '', // 结转金额
                changeReason: '', //换房原因
                agentUser: '', //经办人
                signUser: '', // 签约人
                fList: [],
                attachments: '', //上传附件
                remark: '', //备注
                rentPayMethod: '', //交租方式
                mergeList: '[]',
            },
            dict: {
                changeReason: Dict.NULL,
            },
            increaseYear: 0, // 租金涨幅年
            ymd,
            modal: {
                showRentCustom: false, // 租金自定义弹框
            },
        }
    },
    watch: {
        value: {
            handler(val) {
                Object.assign(this.info, val)
            },
        },
    },

    computed: {
        innerRules() {
            return {
                changeReason: [
                    { required: true, message: `${this.reason}必填` },
                ],
            }
        },
        fListRemark() {
            return this.info.fList.length > 0 ? this.info.fList[0].remark : ''
        },
        reason() {
            return this.isSurrender ? '退租原因' : '换房原因'
        },
        // 租金交租方式是自定义
        isRentCustom() {
            return this.info.rentPayMethod === '20'
        },
        isSurrender() {
            return this.type === '3'
        },
        isChange() {
            return this.type === '4'
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                Dict.get(['change_reason']),
                cInfoList({ pageNo: 1, pageSize: 999 }),
            ])
                .then((args) => {
                    var [dictGroup, customer] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.customerList = customer.data.page.list
                    Object.assign(this.info, this.value)
                    this.increaseYear = this.info.increase.length
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
<style lang="less" scoped></style>
